import {
  FaTasks,
  FaProjectDiagram,
  FaCheckCircle,
  FaSyncAlt,
  FaLaptopCode,
  FaBullhorn,
} from "react-icons/fa";

// Single source of truth for the Services page and the
// /services/:slug detail page.
export const services = [
  {
    slug: "project-management",
    title: "Project Management",
    Icon: FaTasks,
    description:
      "Project planning, governance, stakeholder management, budgeting, risk control, and successful delivery of strategic initiatives.",
    overview:
      "We help organizations plan, execute, and deliver projects on time, within budget, and aligned to business goals. From initiation to closure, our project managers bring proven governance, disciplined risk control, and clear stakeholder communication to keep every initiative on track.",
    offerings: [
      "End-to-end project planning & scheduling",
      "Governance, budgeting & cost control",
      "Risk, issue & dependency management",
      "Stakeholder engagement & reporting",
      "Agile, Waterfall & hybrid delivery",
      "Quality assurance & successful handover",
    ],
    useCases: [
      "Delivering strategic business initiatives",
      "Recovering at-risk or stalled projects",
      "Establishing project governance & controls",
    ],
  },
  {
    slug: "programme-management",
    title: "Programme Management",
    Icon: FaProjectDiagram,
    description:
      "Managing large-scale transformation programmes, portfolio governance, benefits realization, and executive reporting.",
    overview:
      "For complex, multi-project initiatives, we provide programme leadership that coordinates interdependent workstreams toward a single strategic outcome. We align delivery with business benefits and give executives the visibility they need to make confident decisions.",
    offerings: [
      "Large-scale transformation programmes",
      "Portfolio & programme governance",
      "Benefits realization & tracking",
      "Cross-workstream coordination",
      "Executive & board-level reporting",
      "Resource & financial management",
    ],
    useCases: [
      "Leading enterprise transformation programmes",
      "Coordinating multiple interdependent projects",
      "Realizing and tracking business benefits",
    ],
  },
  {
    slug: "test-management",
    title: "Test Management",
    Icon: FaCheckCircle,
    description:
      "Test strategy, quality assurance, UAT management, defect tracking, and end-to-end testing governance.",
    overview:
      "Quality is built in, not bolted on. Our test management services define the right strategy, coordinate testing across teams, and drive defects to closure — so you release with confidence and protect your users and reputation.",
    offerings: [
      "Test strategy & planning",
      "Functional & regression testing",
      "UAT coordination & management",
      "Defect tracking & resolution governance",
      "Automation strategy & tooling",
      "Quality metrics & release readiness",
    ],
    useCases: [
      "Assuring quality on major releases",
      "Managing UAT with business stakeholders",
      "Introducing test automation",
    ],
  },
  {
    slug: "digital-transformation",
    title: "Digital Transformation",
    Icon: FaSyncAlt,
    description:
      "Modernizing business operations, improving customer experiences, and accelerating digital innovation.",
    overview:
      "We help you rethink how technology powers your business — modernizing legacy systems, streamlining operations, and reimagining customer journeys. Our approach balances quick wins with a sustainable roadmap for long-term change.",
    offerings: [
      "Digital strategy & roadmapping",
      "Legacy modernization & cloud migration",
      "Process automation & optimization",
      "Customer experience redesign",
      "Change management & adoption",
      "Data & analytics enablement",
    ],
    useCases: [
      "Modernizing legacy operations",
      "Improving digital customer experience",
      "Automating manual business processes",
    ],
  },
  {
    slug: "website-development",
    title: "Website Development",
    Icon: FaLaptopCode,
    description:
      "Designing and developing responsive, scalable, secure, and business-focused web solutions.",
    overview:
      "From marketing sites to complex web applications, we design and build fast, secure, and responsive digital platforms. Every build is optimized for performance, SEO, and conversion — and crafted to scale with your business.",
    offerings: [
      "Responsive, mobile-first design",
      "Modern front-end (React) development",
      "Scalable APIs & backend integration",
      "Performance, SEO & accessibility",
      "Security & best-practice engineering",
      "Ongoing support & maintenance",
    ],
    useCases: [
      "Launching a new website or platform",
      "Rebuilding a slow or outdated site",
      "Building custom web applications",
    ],
  },
  {
    slug: "digital-marketing",
    title: "Digital Marketing",
    Icon: FaBullhorn,
    description:
      "SEO, content marketing, social media management, campaign execution, and digital growth strategies.",
    overview:
      "We help you reach the right audience and turn attention into growth. Through data-driven SEO, content, and campaign management, we build a digital presence that generates leads and measurable business results.",
    offerings: [
      "Search engine optimization (SEO)",
      "Content & social media marketing",
      "Paid campaigns & lead generation",
      "Email & marketing automation",
      "Analytics & performance tracking",
      "Growth strategy & brand building",
    ],
    useCases: [
      "Growing organic search visibility",
      "Generating qualified leads",
      "Building a consistent brand presence",
    ],
  },
];

export const getService = (slug) => services.find((s) => s.slug === slug);
